import {
  ArrowRightSmallCircleFillIcon,
  CheckFlowerFillIcon,
  FaceFillIcon,
  GraduationcapFillIcon,
  HammerFillIcon,
  MapFillIcon,
  PaperFillIcon,
  PersonStackFillIcon,
  PictureFillIcon,
  SchoolFillIcon,
  SparklingFillIcon,
  SquareStackFillIcon,
} from '@zep-us/zus-icons';

import {
  ZepLogoFullIcon,
  ZepLogoIcon,
  ZepQuizLogoFullIcon,
  ZepQuizLogoIcon,
  ZepSchoolLogoFullIcon,
  ZepSchoolLogoIcon,
} from '@zep/icons';

import { ProductSectionData } from '../components/service/home/LandingProduct/types';

import { CMS_CDN } from './env';

export enum ServiceId {
  ZEP = 'zep',
  ZEP_QUIZ = 'zep-quiz',
  ZEP_SCHOOL = 'zep-school',
}

/**
 * @desc 랜딩 페이지 상수 데이터
 * LandingProduct 컴포넌트에서 사용하는 서비스 섹션 데이터
 */

export const productSectionsData: ProductSectionData[] = [
  {
    id: ServiceId.ZEP,
    logo: ZepLogoFullIcon,
    headerText: 'home:landing.product.zepTitle',
    primaryButton: {
      label: 'home:landing.product.primaryButton',
      href: 'https://zep.us/home/landing',
    },
    secondaryButton: {
      label: 'home:landing.product.secondaryButton',
      href: 'https://zep.us/pricing',
    },
    descriptions: [
      {
        id: 'zep-1',
        icon: PersonStackFillIcon,
        title: 'home:landing.product.meetingTitle',
        description: 'home:landing.product.meetingDescription',
        imageKey: 'zep-feature-meeting',
      },
      {
        id: 'zep-2',
        icon: FaceFillIcon,
        title: 'home:landing.product.communicationTitle',
        description: 'home:landing.product.communicationDescription',
        imageKey: 'zep-feature-communication-localized',
      },
      {
        id: 'zep-3',
        icon: PictureFillIcon,
        title: 'home:landing.product.templatesTitle',
        description: 'home:landing.product.templatesDescription',
        imageKey: 'zep-feature-templates',
      },
      {
        id: 'zep-4',
        icon: HammerFillIcon,
        title: 'home:landing.product.editorTitle',
        description: 'home:landing.product.editorDescription',
        imageKey: 'zep-feature-editor',
      },
    ],
    theme: {
      backgroundColor: '#EAE7FF',
      gradientFrom: '#EAE7FF',
      gradientTo: '#E7E4FF',
      primaryColor: '#6758FF',
      primaryHoverColor: '#5246CC',
      secondaryHoverBg: '#F3F2FF',
      secondaryHoverBorder: '#A49BFF',
      secondaryHoverColor: '#5246CC',
    },
  },
  {
    id: ServiceId.ZEP_QUIZ,
    logo: ZepQuizLogoFullIcon,
    headerText: 'home:landing.product.zepQuizTitle',
    primaryButton: {
      label: 'home:landing.product.primaryButton',
      href: 'https://quiz.zep.us/landing',
    },
    secondaryButton: {
      label: 'home:landing.product.secondaryButton',
      href: 'https://quiz.zep.us/pricing',
    },
    descriptions: [
      {
        id: 'quiz-1',
        icon: ArrowRightSmallCircleFillIcon,
        title: 'home:landing.product.createTitle',
        description: 'home:landing.product.createDescription',
        imageKey: 'quiz-feature-1-localized',
      },
      {
        id: 'quiz-2',
        icon: SparklingFillIcon,
        title: 'home:landing.product.aiTitle',
        description: 'home:landing.product.aiDescription',
        imageKey: 'quiz-feature-2-localized',
      },
      {
        id: 'quiz-3',
        icon: MapFillIcon,
        title: 'home:landing.product.playTitle',
        description: 'home:landing.product.playDescription',
        imageKey: 'quiz-feature-3',
      },
      {
        id: 'quiz-4',
        icon: SquareStackFillIcon,
        title: 'home:landing.product.reportTitle',
        description: 'home:landing.product.reportDescription',
        imageKey: 'quiz-feature-4-localized',
      },
    ],
    theme: {
      backgroundColor: '#E4F8E6',
      gradientFrom: '#E4F8E6',
      gradientTo: '#D0FAD4',
      primaryColor: '#10988D',
      primaryHoverColor: '#0F817E',
      secondaryHoverBg: '#E5FFF9',
      secondaryHoverBorder: '#15B09C',
      secondaryHoverColor: '#0F817E',
    },
  },
  {
    id: ServiceId.ZEP_SCHOOL,
    logo: ZepSchoolLogoFullIcon,
    headerText: 'home:landing.product.zepSchoolTitle',
    primaryButton: {
      label: 'home:landing.product.primaryButton',
      href: 'https://zepschool.us/',
    },
    secondaryButton: {
      label: 'home:landing.product.secondaryButton',
      href: 'https://zepschool.us/pricing',
    },
    descriptions: [
      {
        id: 'school-1',
        icon: GraduationcapFillIcon,
        title: 'home:landing.product.storyTitle',
        description: 'home:landing.product.storyDescription',
        imageKey: 'school-feature-1-localized',
      },
      {
        id: 'school-2',
        icon: PaperFillIcon,
        title: 'home:landing.product.curriculumTitle',
        description: 'home:landing.product.curriculumDescription',
        imageKey: 'school-feature-2-localized',
      },
      {
        id: 'school-3',
        icon: CheckFlowerFillIcon,
        title: 'home:landing.product.progressTitle',
        description: 'home:landing.product.progressDescription',
        imageKey: 'school-feature-3',
      },
      {
        id: 'school-4',
        icon: SchoolFillIcon,
        title: 'home:landing.product.schoolTitle',
        description: 'home:landing.product.schoolDescription',
        imageKey: 'school-feature-4-localized',
      },
    ],
    theme: {
      backgroundColor: '#DBEFFF',
      gradientFrom: '#DBEFFF',
      gradientTo: '#CFEAFF',
      primaryColor: '#0D94FF',
      primaryHoverColor: '#0A81DF',
      secondaryHoverBg: '#E7F4FF',
      secondaryHoverBorder: '#0D94FF',
      secondaryHoverColor: '#0A81DF',
    },
  },
] as const;

/**
 * @desc 서비스 바로가기 숏컷 데이터
 * LandingEduShortcut 컴포넌트에서 사용
 */
export const serviceShortcuts = [
  {
    id: ServiceId.ZEP,
    LogoComponent: ZepLogoIcon,
    title: 'home:landing.shortcut.zep',
    url: 'https://zep.us/home/landing',
    imageUrl: `${CMS_CDN}/medias/9z7bCJzn/RN4/6S40i3Wk87CV3B4Pgt1wRN4/en-US/1/Shortcut_1.webp`,
    gradientFrom: 'from-[#f3f2ff]',
    gradientTo: 'to-[#e7e4ff]',
  },
  {
    id: ServiceId.ZEP_QUIZ,
    LogoComponent: ZepQuizLogoIcon,
    title: 'home:landing.shortcut.zepQuiz',
    url: 'https://quiz.zep.us/landing',
    imageUrl: `${CMS_CDN}/medias/9z7bCJzn/IX5/6Rr9h3Wk87DV3B4Pj81uIX5/en-US/1/Shortcut_2.webp`,
    gradientFrom: 'from-[#e8fcea]',
    gradientTo: 'to-[#d0fad4]',
  },
  {
    id: ServiceId.ZEP_SCHOOL,
    LogoComponent: ZepSchoolLogoIcon,
    title: 'home:landing.shortcut.zepSchool',
    url: 'https://zepschool.us/',
    imageUrl: `${CMS_CDN}/medias/9z7bCJzn/vSv/6Rmvf3Wk87CV3B4Pj86RvSv/en-US/1/Shortcut%203.webp`,
    gradientFrom: 'from-[#e7f4ff]',
    gradientTo: 'to-[#cfeaff]',
  },
] as const;

/**
 * @desc 히어로 섹션 서비스 버튼 데이터
 * LandingEduHero 컴포넌트에서 사용
 */
export const heroServiceButtons = [
  { id: 0, label: 'ZEP', serviceId: ServiceId.ZEP },
  { id: 1, label: 'ZEP QUIZ', serviceId: ServiceId.ZEP_QUIZ },
  { id: 2, label: 'ZEP SCHOOL', serviceId: ServiceId.ZEP_SCHOOL },
] as const;

/**
 * @desc 히어로 섹션 서비스별 비디오 URL
 * LandingEduHero의 HeroVideo 컴포넌트에서 사용
 * - 다국어 지원 필요시: Record<string, string> (locale별 URL)
 * - 단일 URL인 경우: string
 */
export const heroVideoUrls: Record<string, Record<string, string> | string> = {
  [ServiceId.ZEP]: {
    ko: `${CMS_CDN}/medias/9z7bCJzn/OvT/6RxdJ3Wk87DV3dZAo61hOvT/en-US/1/%EC%A0%AD%EC%BD%94%EC%96%B4_%EB%9E%9C%EB%94%A9_%ED%95%9C%EA%B5%AD%EC%96%B4.webm`,
    en: `${CMS_CDN}/medias/9z7bCJzn/ms2/6S1su3Wk87DV3daThM6Rms2/en-US/1/%EC%A0%AD%EC%BD%94%EC%96%B4_%EB%9E%9C%EB%94%A9_%EC%98%81%EC%96%B4.webm`,
    ja: `${CMS_CDN}/medias/9z7bCJzn/1tQ/1s7cf3Wk87CV3ddfCB6S1tQ/en-US/1/%EC%9D%BC%EC%96%B4_ZEP%EC%86%8C%EA%B0%9C%EC%98%81%EC%83%81_-_edited_.webm`,
  },
  [ServiceId.ZEP_QUIZ]: {
    ko: `${CMS_CDN}/medias/9z7bCJzn/Wir/1jZq83Wk87CV3fGJMC1jWir/en-US/1/%EC%A0%AD%ED%80%B4%EC%A6%88-%EB%9E%9C%EB%94%A9_%ED%95%9C%EA%B5%AD%EC%96%B4_1%EB%B2%88-%EC%98%81%EC%83%81_%ED%80%B4%EC%A6%88%ED%92%80%EC%9D%B4_.webm`,
    en: `${CMS_CDN}/medias/9z7bCJzn/WBa/thXij3wK87cuxPUvazLnWBa/en-US/1/%EC%A0%AD%ED%80%B4%EC%A6%88%20%EB%9E%9C%EB%94%A9_%EC%98%81%EC%96%B4_1%EB%B2%88%20%EC%98%81%EC%83%81%28%ED%80%B4%EC%A6%88%ED%92%80%EC%9D%B4%29.webm`,
    ja: `${CMS_CDN}/medias/9z7bCJzn/nsx/2SO493wK87duxPVtAmEdnsx/en-US/1/%EC%A0%AD%ED%80%B4%EC%A6%88%20%EB%9E%9C%EB%94%A9_%EC%9D%BC%EB%B3%B8%EC%96%B4_1%EB%B2%88%20%EC%98%81%EC%83%81%28%ED%80%B4%EC%A6%88%ED%92%80%EC%9D%B4%29.webm`,
  },
  [ServiceId.ZEP_SCHOOL]: `${CMS_CDN}/medias/9z7bCJzn/rBm/6Rp0r3Wk87DV3dfHi76RrBm/en-US/1/%EC%A0%AD%EC%8A%A4%EC%BF%A8_%EB%9E%9C%EB%94%A9.webm`,
};

/**
 * @desc product 섹션 배경 그라디언트 설정
 */
export const PRODUCT_BACKGROUND_CONFIGS = [
  { sectionId: ServiceId.ZEP, gradientFrom: '#F3F2FF', gradientTo: '#FFFFFF' },
  {
    sectionId: ServiceId.ZEP_QUIZ,
    gradientFrom: '#F1FFF3',
    gradientTo: '#FFFFFF',
  },
  {
    sectionId: ServiceId.ZEP_SCHOOL,
    gradientFrom: '#EEF7FF',
    gradientTo: '#FFFFFF',
  },
];

/**
 * @desc 서비스 비교 차트 서비스 데이터
 * LandingChart 컴포넌트에서 사용
 */
export const chartServicesData = [
  {
    id: ServiceId.ZEP,
    name: 'ZEP',
    logo: ZepLogoIcon,
    url: 'https://zep.us/home/landing',
    color: '#6758FF',
  },
  {
    id: ServiceId.ZEP_QUIZ,
    name: 'ZEP QUIZ',
    logo: ZepQuizLogoIcon,
    url: 'https://quiz.zep.us/landing',
    color: '#10988D',
  },
  {
    id: ServiceId.ZEP_SCHOOL,
    name: 'ZEP SCHOOL',
    logo: ZepSchoolLogoIcon,
    url: 'https://zepschool.us/',
    color: '#0D94FF',
  },
];

/**
 * @desc 서비스 비교 차트 기능 데이터
 * LandingChart 컴포넌트에서 사용
 * values: true = 체크, false = X, string = 텍스트 표시
 */
export const chartFeaturesData = [
  {
    id: 'concurrent-users',
    label: 'home:landing.chart.concurrentUsers',
    values: {
      [ServiceId.ZEP]: 'home:landing.chart.concurrentZep',
      [ServiceId.ZEP_QUIZ]: 'home:landing.chart.concurrentQuiz',
      [ServiceId.ZEP_SCHOOL]: 'home:landing.chart.concurrentSchool',
    },
  },
  {
    id: 'long-time-space',
    label: 'home:landing.chart.space',
    values: {
      [ServiceId.ZEP]: true,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: false,
    },
  },
  {
    id: 'customize-space',
    label: 'home:landing.chart.customizeSpace',
    values: {
      [ServiceId.ZEP]: true,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: false,
    },
  },
  {
    id: 'video-call',
    label: 'home:landing.chart.videoCall',
    values: {
      [ServiceId.ZEP]: true,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: false,
    },
  },
  {
    id: 'chat-dm',
    label: 'home:landing.chart.chatDm',
    values: {
      [ServiceId.ZEP]: true,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: true,
    },
  },
  {
    id: 'school-event',
    label: 'home:landing.chart.schoolEvent',
    values: {
      [ServiceId.ZEP]: true,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: true,
    },
  },
  {
    id: 'interactive-edu',
    label: 'home:landing.chart.interactiveEdu',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: true,
    },
  },
  {
    id: 'use-worksheet',
    label: 'home:landing.chart.worksheet',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: false,
      [ServiceId.ZEP_SCHOOL]: true,
    },
  },
  {
    id: 'copy-material',
    label: 'home:landing.chart.copyMaterial',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: true,
      [ServiceId.ZEP_SCHOOL]: true,
    },
  },
  {
    id: 'gamify-edu',
    label: 'home:landing.chart.occasionEdu',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: true,
      [ServiceId.ZEP_SCHOOL]: true,
    },
  },
  {
    id: 'ai-quiz',
    label: 'home:landing.chart.aiQuiz',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: true,
      [ServiceId.ZEP_SCHOOL]: false,
    },
  },
  {
    id: 'learning-history',
    label: 'home:landing.chart.learningHistory',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: true,
      [ServiceId.ZEP_SCHOOL]: false,
    },
  },
  {
    id: 'escape-room-quiz',
    label: 'home:landing.chart.escapeRoom',
    values: {
      [ServiceId.ZEP]: false,
      [ServiceId.ZEP_QUIZ]: true,
      [ServiceId.ZEP_SCHOOL]: false,
    },
  },
];
